import ImageMagnifierLens from "./components/ImageMagnifierLens";
export default ImageMagnifierLens;



// WEBPACK FOOTER //
// ./app/src/indexPackage.ts